import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "submit", "rejectFields", "acceptFields"]
  static values = { rejectPath: String, acceptPath: String }

  connect() {
    this.toggleSubmit()
    this.toggleRejectFields()
    this.toggleAcceptFields()
  }

  updateAction() {
    this.element.action = this.selectTarget.value
    this.toggleSubmit()
    this.toggleRejectFields()
    this.toggleAcceptFields()
  }

  toggleSubmit() {
    this.submitTarget.disabled = !this.selectTarget.value
  }

  // The optional "why is this a false positive?" box is only relevant when the
  // reviewer is rejecting. Reveal it for the reject option, hide it otherwise.
  toggleRejectFields() {
    if (!this.hasRejectFieldsTarget) return
    const isReject = this.rejectPathValue && this.selectTarget.value === this.rejectPathValue
    this.rejectFieldsTarget.classList.toggle("hidden", !isReject)
  }

  // The explanation and citation for an agreement are only rendered for entries that take one
  // (a clinical-probable flag). Reveal them for the accept option, hide them otherwise.
  toggleAcceptFields() {
    if (!this.hasAcceptFieldsTarget) return
    const isAccept = this.acceptPathValue && this.selectTarget.value === this.acceptPathValue
    this.acceptFieldsTarget.classList.toggle("hidden", !isAccept)
  }
}
